import React from "react";
import { Reveal, SectionHeading } from "./Reveal";

export const ChapterSection = ({ id, data, testIdPrefix, itemIdPrefix, eyebrow }) => (
    <section id={id} className="py-16 sm:py-20">
        <SectionHeading eyebrow={eyebrow} title={data.title} intro={data.intro} />
        <div className="mt-12">
            {data.items.map((item, i) => (
                <Reveal key={item.num} delay={i * 0.1}>
                    <article
                        id={`${itemIdPrefix}-${i + 1}`}
                        data-testid={`${testIdPrefix}-card-${item.num}`}
                        className="group grid grid-cols-[64px_1fr] sm:grid-cols-[96px_1fr] gap-4 sm:gap-8 border-t border-[#E4DFD3] py-10 first:border-t-0 first:pt-0 last:pb-0"
                    >
                        <div className="font-serif text-5xl sm:text-7xl font-bold leading-none text-[#DDE5DB] transition-colors duration-500 group-hover:text-[#9AB098] select-none">
                            {item.num}
                        </div>
                        <div>
                            <h3 className="font-serif text-xl sm:text-2xl font-medium text-[#1A1D1A]">{item.title}</h3>
                            <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#6D736D]">{item.body}</p>
                        </div>
                    </article>
                </Reveal>
            ))}
        </div>
    </section>
);
